import fetchUserData from "../data/fetchUserData";

// Redirect to dashboard if already subscribed
export default async function ({ app, redirect, $config }) {
  let userData = app.$localStore.get("userData");
  console.log("isNotSubscribed", userData);
  if (!userData) {
    userData = await fetchUserData($config);
    app.$localStore.set("userData", userData);
  }
  
  if (userData.subscribed && Date.parse(userData.endTimestamp) > Date.now()) {
    return redirect("/pianifica");
  }
}
